export enum UserChangeEmailMessage {
  tokenNotFound = 'TOKEN_NOT_FOUND',
  tokenExpired = 'TOKEN_EXPIRED',
  changeUserEmailError = 'CHANGE_USER_EMAIL_ERROR',
  userAlreadyExists = 'USER_ALREADY_EXISTS',
  success = 'SUCCESS',
}
